import styled from "styled-components";

export const IntroContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  .content {
    figure {
      &.image {
        text-align: center;
      }
      &.image.image-style-side {
        text-align: right;
      }
    }
    img {
      max-width: 100%;
      object-fit: contain;
    }
  }
  .map {
    .addr {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;
    }
    button {
      padding: 5px 10px;
      border-radius: 5px;
    }
  }
  &.theme-0 {
  }
  &.theme-2 {
    max-width: 1240px;
    p {
      color: #999;
      font-weight: 300;
    }
    strong {
      color: #c0a5a5;
    }
    .section {
      &:last-child {
        h3 {
          text-align: right;
          margin-bottom: 0;
          margin-top: 100px;
        }
        .map .addr {
          justify-content: flex-end;
          margin: 20px 0;
          button {
            background: #222;
            color: #fff;
          }
        }
      }
    }
  }
  &.theme-4 {
    text-align: center;
    .content button {
      margin: 50px 0 100px;
      background: #222;
      color: #fff;
      width: 400px;
      height: 70px;
      font-size: 24px;
      border-radius: 10px;
    }
    p {
      color: #999999;
      font-weight: 300;
    }
    strong {
      color: #000;
      font-size: 40px;
    }
    .map .addr {
      justify-content: flex-end;
      button {
        background: #222;
        color: #fff;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    &.theme-4 {
      strong {
        font-size: 30px;
      }
      .content button {
        font-size: 18px;
        width: 300px;
        height: 50px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .map .addr {
      gap: 0;
      justify-content: space-between;
      span {
        max-width: calc(100% - 70px);
      }
    }
    &.theme-2 .section:last-child .map .addr,
    &.theme-4 .map .addr {
      justify-content: space-between;
      text-align: left;
    }
    &.theme-4 {
      strong {
        font-size: 18px;
      }
      .content button {
        font-size: 14px;
        width: 300px;
        height: 50px;
      }
    }
  }
`;

export const HistoryContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  img {
    width: 100%;
    max-width: 1000px;
    display: block;
    margin: auto;
  }
  /* div {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 50px 0;
    &::after {
      content: "";
      width: 2px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      background: #ececec;
    }
    .year {
      font-size: 70px;
      font-weight: 700;
      width: 50%;
      text-align: right;
      padding-right: 80px;
      position: relative;
      &::after {
        content: "";
        background: #00aeef;
        width: 10px;
        height: 10px;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(50%, -50%);
        border-radius: 50%;
        z-index: 3;
      }
    }
    ul {
      width: 50%;
      padding-left: 80px;
      strong {
        display: inline-block;
        color: #00aeef;
        margin-right: 10px;
      }
      li {
        margin-bottom: 15px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  } */
  @media screen and (max-width: 767px) {
    overflow-x: auto;
    img {
      width: auto;
      max-width: 100%;
    }
  }
`;

export const ChartContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  img {
    width: 100%;
    max-width: 900px;
    display: block;
    margin: auto;
  }
  /* .content {
    overflow-x: auto;
    padding: 50px 0;
    background: #f1f4f9;
    .tree {
      > ul {
        display: flex;
        > li {
          margin: auto;
        }
      }
      ul {
        padding-top: 20px;
        position: relative;
        transition: all 0.5s;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        ul::before {
          content: "";
          position: absolute;
          top: 0;
          left: 50%;
          border-left: 1px dotted #ccc;
          width: 0;
          height: 20px;
        }
      }
      li {
        float: left;
        text-align: center;
        list-style-type: none;
        position: relative;
        padding: 20px 2px 0;
        transition: all 0.5s;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        &::before,
        &::after {
          content: "";
          position: absolute;
          top: 0;
          right: 50%;
          border-top: 1px dotted #ccc;
          width: 50%;
          height: 20px;
        }
        &::after {
          right: auto;
          left: 50%;
          border-left: 1px dotted #ccc;
        }

        &:only-child::after,
        &:only-child::before {
          display: none;
        }
        &:only-child {
          padding-top: 0;
        }

        &:first-child::before,
        &:last-child::after {
          border: 0 none;
        }
        &:last-child::before {
          border-right: 1px dotted #ccc;
          border-radius: 0 5px 0 0;
          -webkit-border-radius: 0 5px 0 0;
          -moz-border-radius: 0 5px 0 0;
        }
        &:first-child::after {
          border-radius: 5px 0 0 0;
          -webkit-border-radius: 5px 0 0 0;
          -moz-border-radius: 5px 0 0 0;
        }
      }
      span {
        border: 1px solid #aaa;
        padding: 10px 8px;
        text-decoration: none;
        font-family: "Pretendard";
        background: #fff;
        display: inline-block;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        transition: all 0.5s;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
      }
    }
  } */
  @media screen and (max-width: 767px) {
    overflow-x: auto;
    img {
      width: auto;
      max-width: 100%;
    }
  }
`;

export const DetailImageContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 9999;
  overflow: auto;

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(90deg);
    transform-origin: center center;
  }

  img {
    display: block;
    width: 100vh;
    height: auto;
  }
`;

export const DetailImageWrapper = styled.div`
  position: fixed;
  /* inset: 0; */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 9999;
  overflow: auto;

  .rotated-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    transform: rotate(90deg) translateY(-100%);
    transform-origin: top left;
    width: 100vh;
  }

  img {
    width: 100vh;
    height: auto;
    display: block;
  }
`;
